<template>
  <div class="project">
    <div style="width: 1200px; margin: 0 auto">
      <div style="width: 100%; height: 50px"></div>
      <div
        style="
          line-height: 26px;
          font-size: 26px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #000000;
        "
      >
        乡村振兴<span
          style="
            line-height: 18px;
            font-size: 18px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
            margin-left: 10px;
          "
          >Rural&nbsp;Vitalization</span
        >
      </div>
      <div
        style="width: 54px; height: 2px; background: #3476c1; margin-top: 20px"
      ></div>
      <div
        style="
          width: 1200px;
          margin: 30px auto 0;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <div
          class="project-i"
          v-for="(item, index) in list"
          :key="index"
          v-show="index < 3"
        >
          <a :href="`https://muke.jycyfww.com/#/videolist?courseId=${item.id}`" target="_blank">
              <div style="width: 380px; height: 200px;overflow:hidden">
            <img
            class="hover"
              :src="item.projectImg"
              alt=""
              style="width: 100%; display: block"
            />
          </div>
          <div class="project-i-t">{{ item.name }}</div>
          <div class="project-i-txt">{{ item.remark }}</div>
          </a>
        </div>
        <div v-for="(item, index) in jiaArr" :key="index + 100" style="width: 285px; height: 200px"></div>
      </div>
      <div style="clear: both"></div>
      <a href="https://muke.jycyfww.com/#/videoclass?catalogueId=572" target="_blank" rel="noopener noreferrer">
      <div class="morezanserve" @click="toMore">更多课程</div></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "project",
  data() {
    return {
      list: [
          {
              id: 143,
              projectImg: 'https://dyqc.oss-accelerate.aliyuncs.com/muke/img/prod/98dc0eb83aa74241b8d4f0c6df131b6a.jpg',
              name: '乡村振兴之劳务品牌培育专项训练',
              remark: '农业农村农民问题是关系国计民生的根本性问题，乡村振兴最关键的还是农业兴、农村美、农民富，通过参加乡村振兴之劳务品牌培育专项训练可以不断提高农村劳动力、退役军人等人群的专业技能、职业素养，从而培养、锻炼出建设农村、发展农村的高素质农民群体，为实现伟大的乡村振兴战略奠定基础。'
          },
          {
              id: 139,
              projectImg: 'https://dyqc.oss-accelerate.aliyuncs.com/muke/img/prod/6f534503b2b04cf196a2c15580826f61.jpg',
              name: '高素质农民能力提升培训',
              remark: '加强乡村振兴人才队伍建设，实施高素质农民培育计划，优化学科专业结构，培养乡村规划、设计、建设、管理的专业人才，发现和提高农民、农村人才的整体素质与专业能力，为全面实现乡村的多维度、高精深、系统化的复兴、振兴，提供坚实的人才队伍保障。'
          },
          {
              id: 140,
              projectImg: 'https://dyqc.oss-accelerate.aliyuncs.com/muke/img/prod/14eba2b49d784576acae10e7873d4acd.jpg',
              name: '乡村振兴业务骨干的通用素质培训',
              remark: '抓点带面推进乡村振兴全面展开，创建乡村振兴示范村、镇，离不开乡村振兴业务骨干的的真抓实干；加快培养农村产业带头人、乡村振兴业务骨干势在必行；从基本素质训练、安全意识培训、心理健康疏导到疫情防控管理、专项知识锻炼的全面、系统培训十分重要，将对提高乡村振兴业务骨干的整体水平起到助推作用。'
          },
      ],
      jiaArr: []
    };
  },
  created() {
    // this.$axios.get("/v1/cloud/common/project/home", {}).then(({ data }) => {
    //   if (data) {
    //     data.forEach(function (item, index) {
    //       item.remark = item.remark.substr(0, 34) + "...";
    //     });
    //     this.list = data;
    //     this.jiaArr = data.length < 8 ? 8 - data.length : 0
    //   }
    // });
  },
  mounted() {
    //修改dom元素
    // this.timer = setTimeout(()=> {
    //     var domList = document.querySelectorAll(".project-i-txt");
    //     var newList = Array.from(domList);
    //     newList.forEach((item,index,array)=>{
    //         console.log(66666,domList[index].innerText);
    //         var str = domList[index].innerText;
    //         str = str.substr(0,34) + '...' ;
    //         domList[index].innerText = str;
    //         console.log(77777,domList[index].innerText);
    //     })
    // }, 1000);
  },
  beforeDestroy() {
    //清除计时器
    // clearInterval(this.timer);
  },
  methods: {
    toMore() {
    //   sessionStorage.setItem("tabIndex", 7);
    //   this.$router.push("/project");
    },
    toDetail(id) {
      sessionStorage.setItem("tabIndex", 7);
      this.$router.push({
        path: "/projectDetail",
        query: {
          id,
        },
      });

    },
    limitNumber(txt, idName, num) {
      var str = txt;
      str = str.substr(0, num) + "...";
      var id = document.getElementById(idName);
      id.innerText = str;
    },
  },
};
</script>

<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.project {
  width: 100%;
  height: 563px;
  background: #ffffff;
  .project-i {
    width: 380px;
    height: 316px;
    background: #fff;
    margin-bottom: 30px;
    cursor: pointer;
    box-shadow: 0px 0px 12px 0px rgba(207, 206, 206, 0.54);
    cursor: pointer;
    .project-i-t {
      width: 100%;
      padding-left: 10px;
      height: 16px;
      line-height: 16px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #333333;
      margin: 19px 0px 10px 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .project-i-txt {
      width: 100%;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #888888;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      min-height: 50px;
    }
  }
  .project-i:hover {
    box-shadow: 1px 20px 50px 0px rgba(207, 207, 207, 1);
  }
  .project-i:hover .project-i-t {
    color: #3476C1;
  }
  .morezanserve {
      margin: 10px auto 0;
      width: 150px;
      height: 40px;
      border: 1px solid #5fc0e4;
      border-radius: 3px;
      line-height: 40px;
      color: #5FC0E4;
      box-sizing: border-box;
      text-indent: 34px;
      background-image: url('../../static/common/morezan.png');
      background-size: 15px 15px;
      background-repeat: no-repeat;
      background-position: 101px 12px;
      cursor: pointer;
    }
    .morezanserve:hover {
    background-color: #5FC0E4;
    background-image: url('../../static/common/morezan1.png');
    color: #fff;
  }
}
</style>